import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 封装axios
import axios from 'axios'
Vue.prototype.$axios = axios
import qs from 'qs'
Vue.prototype.$qs = qs


// npm install --save vant@2.12.53
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

// npm install amfe-flexible --save // 安装 amfe-flexible 
// npm i postcss-pxtorem@5.1.1  // 自动将px转换为rem
import 'amfe-flexible/index.js'

// npm install vue-seamless-scroll --save
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)

//导入全局请求
import request from '@/utils/request.js';
Vue.prototype.BASE_URL = request.BASE_URL
Vue.prototype.$request = request.request;
import * as utils from './utils/util'
Vue.prototype.$utils = utils;



import download from "./components/download" // 下载弹框组件
Vue.component("download", download);



// userAgent client
const userAgent = navigator.userAgent
const userAgentL = userAgent.toLowerCase()
Vue.prototype.$client = Vue.client = {
  WEBKIT: userAgentL.indexOf('applewebkit') > -1, // 苹果、谷歌内核
  ANDROID: userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1, // android终端或者uc浏览器
  IPHONE: userAgent.indexOf('iPhone') > -1, // 是否为iPhone或者QQHD浏览器
  QQBROWSER: userAgent.indexOf('QQBrowser') > -1, // 是否QQ浏览器
  WEIXIN: userAgent.indexOf('MicroMessenger') > -1, // 是否微信
  QQ: userAgent.match(/QQ/i) == "QQ" ? true : false, // 是否QQ
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
